import Marquee from "react-fast-marquee";
import { BRANDS } from "@/data/content";

export function BrandMarquee() {
  return (
    <div className="bg-darknavy py-6 border-y border-gold/20" data-testid="brand-marquee">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {BRANDS.map((b) => (
          <span key={b.name} className="mx-8 flex items-center gap-8">
            <span className="font-display text-lg md:text-xl font-light uppercase tracking-[0.3em] text-cream/85">
              {b.name}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
